// wherever TopbarSearch lives
import { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import type { RootState } from "../store";
import Theme from "../utils/theme";
import { InputAdornment, IconButton, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { lighten } from "@mui/material/styles";
import { useNavigate, createSearchParams } from "react-router-dom";

export default function TopbarSearch({ placeholder = "Search…" }) {
    const themeState = useSelector((root: RootState) => root.theme);
    const theme = useMemo(() => Theme(themeState.mode), [themeState.mode]);
    const navigate = useNavigate();

    const [value, setValue] = useState("");

    const handleSearch = () => {
        const q = value.trim();
        const params = createSearchParams(q ? { q } : {});
        navigate(`/search?${params.toString()}`);
    };

    return (
        <TextField
            variant="outlined"
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
                if (e.key === "Enter") handleSearch();
            }}
            fullWidth
            sx={{
                "& .MuiOutlinedInput-root": {
                    borderRadius: 4,
                    backgroundColor: lighten(theme.palette.primary.main, 0.4),
                    backdropFilter: "blur(8px)",
                    height: "45px",
                },
            }}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <IconButton size="small" onClick={handleSearch} aria-label="Search">
                            <SearchIcon color="action" />
                        </IconButton>
                    </InputAdornment>
                ),
                endAdornment: value && (
                    <InputAdornment position="end">
                        <IconButton size="small" onClick={() => setValue("")} aria-label="Clear">
                            <ClearIcon fontSize="small" />
                        </IconButton>
                    </InputAdornment>
                ),
            }}
        />
    );
}
